if (!global._babelPolyfill) {
    require('babel-polyfill');
}

require(
    __dirname + "/main.scss"
);

import(__dirname + "/patterns/select-product/select-product.js");
import(__dirname + "/patterns/subscribe-form/subscribe-form.js");
import(__dirname + "/patterns/subscribe-form-arbitrary/subscribe-form-arbitrary.js");
